/* eslint-disable spire/fenced-imports */
import translate from "@insite/client-framework/Translate";
import { SelectBrandsFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import DynamicDropdown from "@insite/mobius/DynamicDropdown";
import StandardControl from "@insite/shell-public/Components/StandardControl";
import { EditorTemplateProps } from "@insite/shell-public/EditorTemplateProps";
import { loadSelectBrands } from "@insite/shell/Store/PageEditor/PageEditorActionCreators";
import { SelectBrandModel } from "@insite/shell/Store/PageEditor/PageEditorState";
import ShellState from "@insite/shell/Store/ShellState";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
/* eslint-enable spire/fenced-imports */

interface CustomBrandInfo {
    id?: string;
    name?: string;
    logoSmallImagePath?: string;
    urlSegment?: string;
}

interface State {
    selectBrands: SelectBrandModel[];
    isFocused: boolean;
    loaded?: boolean;
}

type OwnProps = EditorTemplateProps<CustomBrandInfo, SelectBrandsFieldDefinition>;

const mapStateToProps = (state: ShellState) => {
    const selectBrands = state.pageEditor.selectBrandsState?.selectBrands || [];
    const websiteId = state.shellContext.websiteId;

    return {
        selectBrands,
        initialFilter: `logoSmallImagePath ne '' and Products/any(product: product/Categories/any(category: category/websiteId eq ${websiteId}))`,
    };
};

const mapDispatchToProps = {
    loadSelectBrands,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

class CustomSelectBrandsField extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            selectBrands: [],
            isFocused: false,
        };
    }

    componentDidMount(): void {
        if (this.props.fieldValue?.id) {
            this.loadSelectBrands([this.props.fieldValue.id]);
        } else {
            this.loadSelectBrands([]);
        }
    }

    private loadSelectBrands(brands: string[], nameFilter?: string) {
        let queryFilter = this.props.initialFilter;
        if (nameFilter) {
            queryFilter = `${queryFilter} and contains(name,'${nameFilter}') eq true`;
        }
        this.props.loadSelectBrands({
            $filter: queryFilter,
            $select: "id,name,logoSmallImagePath,urlSegment",
            $orderBy: "name",
        });
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.selectBrands !== this.props.selectBrands || prevProps.fieldValue !== this.props.fieldValue) {
            // TODO ISC-12679 - Redesign so that this can be moved to a field of the class rather than state.
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                selectBrands: this.props.selectBrands?.filter(brand => brand.id !== this.props.fieldValue?.id) || [],
                loaded: !!this.props.selectBrands,
            });
        }
    }

    onChange = (value?: string) => {
        if (!value) {
            return;
        }

        const found = this.props.selectBrands.find(brand => brand.id === value);
        this.props.updateField(this.props.fieldDefinition.name, found!);
        this.loadSelectBrands([value]);

        const inputField = document.getElementById("custom-brand-dropdown") as HTMLInputElement;
        if (inputField) {
            const selectedBrandNameSpan = inputField.nextElementSibling as HTMLSpanElement;
            setTimeout(() => {
                selectedBrandNameSpan.innerText = found?.name || "";
            }, 100);
        }
    };

    render() {
        const { selectBrands, loaded } = this.state;

        const options = selectBrands.map(option => ({ optionText: option.name, optionValue: option.id }));

        return (
            <StandardControl fieldDefinition={this.props.fieldDefinition as any}>
                {loaded && (
                    <DynamicDropdown
                        uid="custom-brand-dropdown"
                        onSelectionChange={this.onChange}
                        options={options}
                        placeholder={translate("Select a Brand")}
                        selected={this.props.fieldValue?.name}
                    />
                )}
            </StandardControl>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomSelectBrandsField as any);
